import React from "react";
import { Button, Divider, Flex, HorizontalToolbar, isNullish } from "@theorgchartdev/storybook";
import ColumnDisplayMenu from "./ColumnDisplayMenu/ColumnDisplayMenu";
import CompositeTableSearchControls from "../../Blocks/Composites/CompositeChartSearch/CompositeTableSearchControls";
import { useReportingContext } from "@/providers/ReportsProvider";
import { appstr } from "@coreapp/utils/appstr";

const MainToolbarReports = () => {
  const {
    currentOpenReport,
    reportSearchState,
    setReportSearchState,
    UpdateSearchResults,
    searchCtrl,
    isSaving,
    SaveReportChanges,
    marshalledFilters
  } = useReportingContext();

  const queryOptions = { filters: marshalledFilters, mode: "reporting" };

  if (!isNullish(currentOpenReport?.ID)) {
    queryOptions["reportId"] = currentOpenReport.ID;
  }

  return (
    <HorizontalToolbar
      leftContent={
        <CompositeTableSearchControls
          sessionKeyContextId={`reports_${currentOpenReport?.ID}`}
          UpdateSearchResultContext={UpdateSearchResults}
          projectFields={reportSearchState.columnNames}
          searchCtrlContext={searchCtrl}
          prefixId={"reports"}
          queryChartId={currentOpenReport?.chartID}
          queryOptions={queryOptions}
          showAllFieldNames={true}
        />
      }
      rightContent={
        <Flex gap="16px" alignItems="center">
          <ColumnDisplayMenu
            searchCtrl={searchCtrl}
            searchState={reportSearchState}
            setSearchState={setReportSearchState}
            showAllFieldNames={true}
          />
          <div className={"ocn-toolbar-horizontal-divider"}>
            <Divider vertical />
          </div>
          <Button
            dataTestId={"reports-save-button"}
            className={"oc-special-secondary"}
            modifier={"secondary"}
            onClick={SaveReportChanges}
            loading={isSaving}
          >
            {appstr("Save Report")}
          </Button>
        </Flex>
      }
      size={"large"}
    />
  );
};

export default MainToolbarReports;
